/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PlaylistFullWithoutTracks } from './PlaylistFullWithoutTracks';
import {
    PlaylistFullWithoutTracksFromJSON,
    PlaylistFullWithoutTracksFromJSONTyped,
    PlaylistFullWithoutTracksToJSON,
} from './PlaylistFullWithoutTracks';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface PlaylistsResponseFull
 */
export interface PlaylistsResponseFull {
    /**
     * 
     * @type {number}
     * @memberof PlaylistsResponseFull
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistsResponseFull
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistsResponseFull
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof PlaylistsResponseFull
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof PlaylistsResponseFull
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof PlaylistsResponseFull
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof PlaylistsResponseFull
     */
    version: VersionMetadata;
    /**
     * 
     * @type {Array<PlaylistFullWithoutTracks>}
     * @memberof PlaylistsResponseFull
     */
    data?: Array<PlaylistFullWithoutTracks>;
}

/**
 * Check if a given object implements the PlaylistsResponseFull interface.
 */
export function instanceOfPlaylistsResponseFull(value: object): value is PlaylistsResponseFull {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function PlaylistsResponseFullFromJSON(json: any): PlaylistsResponseFull {
    return PlaylistsResponseFullFromJSONTyped(json, false);
}

export function PlaylistsResponseFullFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlaylistsResponseFull {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PlaylistFullWithoutTracksFromJSON)),
    };
}

export function PlaylistsResponseFullToJSON(value?: PlaylistsResponseFull | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PlaylistFullWithoutTracksToJSON)),
    };
}

